import { useEffect, useState } from 'react';
import { ReactComponent as Bad } from '../../assets/icons/bad.svg';
import { ReactComponent as False } from '../../assets/icons/false.svg';
import { ReactComponent as Good } from '../../assets/icons/good.svg';
import { ReactComponent as Neutral } from '../../assets/icons/neutral.svg';
import { ReactComponent as True } from '../../assets/icons/true.svg';
import { ReactComponent as FriendlynessSliderBackground } from './friendlynessslider_background.svg';
import { ReactComponent as FriendlynessSliderKnob } from './friendlynessslider_knob.svg';
import { ReactComponent as NumberSliderBackground } from './numberslider_background.svg';
import { ReactComponent as NumberSliderKnob } from './numberslider_knob.svg';
import './QuizInteraction.sass';
import { ReactComponent as TrueFalseKnob } from './truefalse_knob.svg';

const QuizInteraction = ({ type, data, onAnswered }) => {
	switch (type) {
		case 'multiplechoice':
			return <QuizMultipleChoiceInteraction data={data} onAnswered={onAnswered} />
		case 'numberslider':
			return <QuizNumberSliderInteraction data={data} onAnswered={onAnswered} />
		case 'friendlynessslider':
			return <QuizFriendlynessSliderInteraction data={data} onAnswered={onAnswered} />
		case 'truefalse':
			return <QuizTrueFalseInteraction data={data} onAnswered={onAnswered} />
		default:
			return <></>;
	}
};

export default QuizInteraction;

const QuizMultipleChoiceInteraction = (props) => {
	const [answerIndex, setAnswerIndex] = useState(undefined);

	const data = props.data.map((option) => !option.includes('<wbr>') ? option : [].concat(...option.split('<wbr>').map(part => [part, '\u00AD'])).join(''));

	useEffect(() => {
		if (answerIndex !== undefined) {
			window.vibrate();
			setTimeout(() => {
				props.onAnswered(props.data[answerIndex]);
			}, 1000);
		}
	}, [answerIndex, props]);

	return <div className="quizinteraction quizinteraction--multiplechoice text-white rounded-full shadow-lg overflow-hidden flex justify-items-stretch items-stretch text-base lg:text-lg">
		<button
			className="bg-blumine w-1/2 font-bold"
			onClick={() => {
				if (!answerIndex) setAnswerIndex(0);
			}}
			type="button"
			style={{
				width: answerIndex !== undefined ? (answerIndex === 0 ? '100%' : '0%') : '100%'
			}}>
			<span>{(answerIndex === undefined || answerIndex === 0) && data[0]}</span>
		</button>
		<button
			className="bg-cadillac w-1/2 font-bold"
			onClick={() => {
				if (!answerIndex) setAnswerIndex(1);
			}}
			type="button"
			style={{
				width: answerIndex !== undefined ? (answerIndex === 1 ? '100%' : '0%') : '100%'
			}}>
			<span>{(answerIndex === undefined || answerIndex === 1) && data[1]}</span>
		</button>
		{data.length > 2 && <button
			className="bg-accent w-1/2 font-bold"
			type="button"
			onClick={() => {
				if (!answerIndex) setAnswerIndex(2);
			}}
			style={{
				width: answerIndex !== undefined ? (answerIndex === 2 ? '100%' : '0%') : '100%'
			}}>
			<span>{(answerIndex === undefined || answerIndex === 2) && data[2]}</span>
		</button>}
	</div>;
};

const QuizNumberSliderInteraction = (props) => {
	const [isMoving, setIsMoving] = useState(false);
	const [movingSince, setMovingSince] = useState(undefined);
	const [knobOffset, setKnobOffset] = useState(32);

	useEffect(() => { }, [isMoving, movingSince, knobOffset]);

	const onMove = (event) => {
		if (isMoving) {
			let x;

			if (event.type.startsWith('touch')) {
				const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
				const touch = evt.touches[0] || evt.changedTouches[0];
				x = touch.pageX;
			} else if (event.type.startsWith('mouse')) {
				x = event.clientX;
			}

			const percentage = (x / window.innerWidth) * 100;

			if (percentage < 90 && percentage > 10) {
				setKnobOffset(percentage);
			}
		}
	};

	const getAnswerValue = () => {
		if (props.data[2] < 50) {
			return Math.max(props.data[0], Math.round(((knobOffset - 10) / 80) * props.data[2]));
		} if (props.data[2] < 500) {
			return Math.max(props.data[0], Math.round(Math.round(((knobOffset - 10) / 80) * props.data[2]) / 10) * 10);
		}
		return Math.max(props.data[0], Math.round(Math.round(((knobOffset - 10) / 80) * props.data[2]) / 100) * 100);

	}

	const hasMovedEnough = () => movingSince && movingSince + 0.1 <= new Date().valueOf() / 1000;

	const submitAnswer = () => {
		if (hasMovedEnough()) {
			setTimeout(() => {
				props.onAnswered(getAnswerValue());
			}, 400);
		}
	}

	return <div className="quizinteraction quizinteraction--numberslider text-blumine font-bold -mx-6 mt-4 mb-2">
		<div
			className="relative"
			onMouseDown={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onTouchStart={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onMouseUp={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onTouchCancel={() => { setIsMoving(false); window.vibrate(1); }}
			onTouchEnd={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onMouseMove={onMove}
			onTouchMove={onMove}>

			<NumberSliderBackground className="w-full" />
			<NumberSliderKnob
				className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2"
				style={{
					left: `calc(${knobOffset}%)`,
				}}
			/>

			<div
				className="absolute bg-cadillac text-white p-4 shadow-md bottom-16 rounded-full origin-center"
				style={{
					left: `${knobOffset}%`,
					transform: (isMoving || hasMovedEnough()) ? 'scale(1.5) translateX(-33.333%)' : 'scale(0) translateX(-100%)',
					transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1)',
				}}>
				<span
					className="inline-block"
					style={{
						transform: `scale(${1 + ((knobOffset / 100) * 1) - 0.5})`,
					}}>{getAnswerValue()}
				</span>
			</div>
		</div>
		<div className="flex justify-around mt-4 select-none">
			<span>{props.data[0]}</span>
			<span className="transform scale-125">{props.data[1]}</span>
			<span className="transform scale-150">{props.data[2]}</span>
		</div>
	</div>;
};

const QuizFriendlynessSliderInteraction = (props) => {
	const [isMoving, setIsMoving] = useState(false);
	const [movingSince, setMovingSince] = useState(null);
	const [knobOffset, setKnobOffset] = useState(50);

	useEffect(() => { }, [isMoving, movingSince, knobOffset]);

	const onMove = (event) => {
		if (isMoving) {
			let x;

			if (event.type.startsWith('touch')) {
				const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
				const touch = evt.touches[0] || evt.changedTouches[0];
				x = touch.pageX;
			} else if (event.type.startsWith('mouse')) {
				x = event.clientX;
			}

			const percentage = (x / window.innerWidth) * 100;

			if (percentage < 90 && percentage > 10) {
				setKnobOffset(percentage);
			}
		}
	};

	const hasMovedEnough = () => movingSince !== null && movingSince + 0.1 <= new Date().valueOf() / 1000;

	const getAnswerValue = () => knobOffset < 35 ? props.data[0] : (knobOffset > 65 ? props.data[2] : props.data[1])

	const submitAnswer = () => {
		if (hasMovedEnough()) {
			setTimeout(() => {
				props.onAnswered(getAnswerValue());
			}, 400);
		}
	}

	return <div className="quizinteraction quizinteraction--friendlynessslider text-blumine font-bold -mx-6 mt-4 mb-2">
		<div
			className="relative"
			onMouseDown={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onTouchStart={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onMouseUp={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onTouchCancel={() => { setIsMoving(false); window.vibrate(1); }}
			onTouchEnd={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onMouseMove={onMove}
			onTouchMove={onMove}>

			<FriendlynessSliderBackground className="w-full" />
			<FriendlynessSliderKnob
				className="absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2"
				style={{
					left: `calc(${knobOffset}%)`,
				}}
			/>

			<div
				className="absolute bg-white p-4 shadow-md bottom-16 rounded-full origin-center"
				style={{
					height: '56px',
					width: '56px',
					left: `calc(${knobOffset}%)`,
					transform: (isMoving || hasMovedEnough()) ? 'scale(1.5) translateX(-33.333%)' : 'scale(0) translateX(-100%)',
					transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1)',
				}}>
				<Bad
					className="transition-all absolute top-1/2 left-1/2"
					style={{
						transform: `translate(-50%, -50%) ${knobOffset < 35 ? 'scale(1)' : 'scale(0)'}`,
					}}
				/>
				<Good
					className="transition-all absolute top-1/2 left-1/2"
					style={{
						transform: `translate(-50%, -50%) ${knobOffset > 65 ? 'scale(1)' : 'scale(0)'}`,
					}}
				/>
				<Neutral
					className="transition-all absolute top-1/2 left-1/2"
					style={{
						transform: `translate(-50%, -50%) ${knobOffset > 35 && knobOffset < 65 ? 'scale(1)' : 'scale(0)'}`,
					}}
				/>
			</div>
		</div>
		<div className="flex justify-around mt-4 select-none">
			<Bad /* onClick={() => { setKnobOffset(33); setTimeout(() => { submitAnswer(props.data[0]); }, 600); }} */ />
			<Neutral /* onClick={() => { setKnobOffset(50); setTimeout(() => { submitAnswer(props.data[1]); }, 600); }} */ />
			<Good /* onClick={() => { setKnobOffset(66); setTimeout(() => { submitAnswer(props.data[2]); }, 600); }} */ />
		</div>
	</div>;
};

const QuizTrueFalseInteraction = (props) => {
	const [isMoving, setIsMoving] = useState(false);
	const [movingSince, setMovingSince] = useState(null);
	const [knobOffset, setKnobOffset] = useState(50);
	const [isConfirmed, setIsConfirmed] = useState(false);

	useEffect(() => { }, [isMoving, movingSince, knobOffset]);

	const onMove = (event) => {
		if (isMoving && !isConfirmed) {
			let x;

			if (event.type.startsWith('touch')) {
				const evt = (typeof event.originalEvent === 'undefined') ? event : event.originalEvent;
				const touch = evt.touches[0] || evt.changedTouches[0];
				x = touch.pageX;
			} else if (event.type.startsWith('mouse')) {
				x = event.clientX;
			}

			const percentage = (x / window.innerWidth) * 100;

			setKnobOffset(percentage);
		}
	};

	const submitAnswer = (answer = undefined) => {
		if (!isConfirmed) {
			if (knobOffset < 35) {
				answer = props.data[0];
				setKnobOffset(0);
			} else if (knobOffset > 65) {
				answer = props.data[1];
				setKnobOffset(100);
			} else {
				setKnobOffset(50);
			}

			if (answer !== undefined) {
				setIsConfirmed(true);
				setTimeout(() => {
					props.onAnswered(answer);
				}, 600);
			}
		}
	};

	return <div className="quizinteraction quizinteraction--truefalse shadow-md rounded-full">
		<div
			className="relative h-full w-full flex justify-between"
			onMouseDown={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onTouchStart={() => { setIsMoving(true); window.vibrate(1); setMovingSince(new Date().valueOf() / 1000); }}
			onMouseUp={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onTouchCancel={() => { setIsMoving(false); window.vibrate(1); }}
			onTouchEnd={() => { setIsMoving(false); window.vibrate(1); submitAnswer(); }}
			onMouseMove={onMove}
			onTouchMove={onMove}>

			<TrueFalseKnob
				className="quizinteraction quizinteraction--truefalse__knob absolute top-1/2 transform -translate-y-1/2 -translate-x-1/2"
				style={{
					left: `max(30px, min(calc(100% - 30px), calc(${knobOffset}%)))`,
					transition: isConfirmed ? 'left 200ms ease-in-out' : '',
				}}
			/>

			<False className="h-full m-4" onClick={() => { setKnobOffset(0); setTimeout(() => { submitAnswer(props.data[0]); }, 600); }} />
			<True className="h-full m-4" onClick={() => { setKnobOffset(100); setTimeout(() => { submitAnswer(props.data[1]); }, 600); }} />
		</div>
	</div>;
};
